"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchCheckTrustedVerificationStatus = void 0;
const fetchCheckTrustedVerificationStatus = (api, progressId, body) => api.POST(`${window.MIDDLEWARE_AUTH_SERVICE_HOST}/authorize/biometric-trusted-confirmation/status`, body, {
    headers: {
        progressId,
    },
});
exports.fetchCheckTrustedVerificationStatus = fetchCheckTrustedVerificationStatus;
//# sourceMappingURL=resolver.js.map